import { useTranslation } from 'react-i18next';
import { RetryQueryAlert } from '@/components/alerts/retry-query-alert';
import { DataTable } from '@/components/data-table/data-table';
import { DataTableFilterMenu } from '@/components/data-table/data-table-filter-menu';
import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import { DataTableSortList } from '@/components/data-table/data-table-sort-list';
import { GET_TRANSITS_KEY } from '@/services/apis/queries/transits/use-get-transits';
import { useTransitsTable } from './hooks/use-transits-table';

export function Transits() {
  const { t } = useTranslation('transits');
  const { table, query } = useTransitsTable();

  if (query.isPending) {
    return <DataTableSkeleton columnCount={4} filterCount={3} rowCount={10} />;
  }
  if (query.isError) {
    return (
      <RetryQueryAlert message={t('listError')} queryKey={GET_TRANSITS_KEY} />
    );
  }

  return (
    <div aria-busy={query.isFetching} className='flex min-h-0 flex-1 flex-col'>
      <DataTable className='min-w-0' table={table}>
        <div
          className='flex w-full items-start justify-between gap-2 p-1'
          role='toolbar'
        >
          <div className='flex flex-1 flex-wrap items-center gap-2'>
            <DataTableFilterMenu table={table} />
            <DataTableSortList table={table} />
          </div>
        </div>
      </DataTable>
    </div>
  );
}
